import {useTranslation} from 'next-i18next';
import {useMemo} from 'react';

import useIsMobile from '@/src/hooks/useIsMobile';
import {ClinicAddressWidgetLayoutProps} from '@/src/profile/accountSettings/components/types/ClinicAddressWidgetLayoutTypes';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, PageTitle, Text} from '@/src/ui';

import css from '../styles/ClinicAddressWidgetLayout.module.css';

const ClinicAddressWidgetLayout = ({
  address,
  zipcode,
  country,
  state,
  city,
  onChangeAddressClick,
}: ClinicAddressWidgetLayoutProps): JSX.Element => {
  const {t} = useTranslation(TextLocal.LOCALE_SOURCE.COMMON);
  const {isMaxWidth900} = useIsMobile();

  const wordSeparator = useMemo(() => {
    return (
      <div className={css.wordSeparator}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          color={Text.COLOR.GREY}
          fontWeight={Text.FONT_WEIGHT.NORMAL}
        >
          {'|'}
        </Text>
      </div>
    );
  }, []);

  return (
    <div className={css.widget}>
      <PageTitle
        offset={PageTitle.BOTTOM_OFFSET.OFFSET_15}
        title={t('profile.address')}
      />
      <div className={css.content}>
        <div className={css.leftContentPart}>
          <Text
            fontWeight={Text.FONT_WEIGHT.BOLD}
            fontSize={Text.FONT_SIZE.SIZE_18}
            color={Text.COLOR.PRIMARY}
          >
            {address}
          </Text>
          <div className={css.leftBottomContentPart}>
            <Text
              fontWeight={Text.FONT_WEIGHT.BOLD}
              fontSize={Text.FONT_SIZE.SIZE_18}
              color={Text.COLOR.PRIMARY}
            >
              {`${zipcode} ${city} `}
            </Text>
            {!isMaxWidth900 && (
              <>
                {wordSeparator}
                <Text
                  fontSize={Text.FONT_SIZE.SIZE_16}
                  color={Text.COLOR.GREY}
                  fontWeight={Text.FONT_WEIGHT.NORMAL}
                >
                  {`${state}`}
                </Text>
              </>
            )}
            {wordSeparator}
            <Text
              fontSize={Text.FONT_SIZE.SIZE_16}
              color={Text.COLOR.GREY}
              fontWeight={Text.FONT_WEIGHT.NORMAL}
            >
              {`${country}`}
            </Text>
          </div>
        </div>
        <div className={css.rightContentPart}>
          <Button
            color={Button.COLOR.SECONDARY}
            border={Button.BORDER.BOLD}
            onClick={onChangeAddressClick}
            height={Button.HEIGHT.SMALL}
          >
            <TextLocal id={'profile.edit'} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ClinicAddressWidgetLayout;
